var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 1.75C8.90001 1.75 10.9 3.75 10.9 6.15C10.9 8.55 8.90001 10.55 6.50001 10.55C4.10001 10.55 2.10001 8.55 2.10001 6.15C2.10001 3.75 4.10001 1.75 6.50001 1.75ZM6.50001 0.25C3.20001 0.25 0.600006 2.85 0.600006 6.15C0.600006 9.45 3.20001 12.05 6.50001 12.05C9.80001 12.05 12.4 9.45 12.4 6.15C12.4 2.85 9.80001 0.25 6.50001 0.25Z",
    fill: "#037A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.7499L9.90001 9.6499",
    stroke: "#037A9A",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1536ba69c7fb334a3df336d836ec7425.svg";
export { ForwardRef as ReactComponent };